import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconAdvancedTooltip = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 47 48" fill="none">
      <path
        clipRule="evenodd"
        fillRule="evenodd"
        d="M28.5002 -8.46049C12.9968 -8.46049 0.427246 4.10907 0.427246 19.6124C0.427246 35.1158 12.9968 47.6853 28.5002 47.6853C44.0035 47.6853 56.5731 35.1158 56.5731 19.6124C56.5731 4.10907 44.0035 -8.46049 28.5002 -8.46049ZM5.23975 19.6124C5.23975 6.76694 15.6547 -3.64799 28.5002 -3.64799C41.3456 -3.64799 51.7606 6.76694 51.7606 19.6124C51.7606 32.4579 41.3456 42.8728 28.5002 42.8728C15.6547 42.8728 5.23975 32.4579 5.23975 19.6124ZM28.5002 32.4458C26.7283 32.4458 25.2918 31.0093 25.2918 29.2374V19.6124C25.2918 17.8405 26.7283 16.4041 28.5002 16.4041C30.2721 16.4041 31.7085 17.8405 31.7085 19.6124V29.2374C31.7085 31.0093 30.2721 32.4458 28.5002 32.4458ZM28.5002 13.1958C26.7283 13.1958 25.2918 11.7593 25.2918 9.98742C25.2918 8.21551 26.7283 6.77909 28.5002 6.77909C30.2721 6.77909 31.7085 8.21551 31.7085 9.98742C31.7085 11.7593 30.2721 13.1958 28.5002 13.1958Z"
        fill="#EDEDF8"
      />
    </SvgIcon>
  )
}
